import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { is401 } from "../errors/ErrorConstants";
import { BASE_URL } from "../utils/EmpUtil";

export default class PreOrderUEVClient {
  static baseUrlEmp = BASE_URL;

  /**
   * Record a dealer's agreement acceptance.
   * @param {{ dealerCommonId: string, dealerName: string, acceptance: string, updatedBy: string }} payload
   * @returns {Promise<void>}
   */
  static async createOrUpdateStepStatus(payload) {
    const url = `${this.baseUrlEmp}/dealer/onboard/agreement/status`;

    try {
      await axios.post(url, payload);
    } catch (error) {
      if (is401(error)) AuthenticationFailureHandler.execute();
      throw error;
    }
  }

  static async getAgreementStatus(dealerCommonId) {
    const url = `${this.baseUrlEmp}/dealer/onboard/agreement/status`;

    try {
      const response = await axios.get(url, { params: { dealerCommonId } });
      return response.data;
    } catch (error) {
      if (is401(error)) AuthenticationFailureHandler.execute();
      throw error;
    }
  }
}
